import { render, staticRenderFns } from "./MetaInsightsChannels.vue?vue&type=template&id=7f0bcf08&scoped=true"
import script from "./MetaInsightsChannels.vue?vue&type=script&lang=js"
export * from "./MetaInsightsChannels.vue?vue&type=script&lang=js"
import style0 from "./MetaInsightsChannels.vue?vue&type=style&index=0&id=7f0bcf08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0bcf08",
  null
  
)

export default component.exports